export const recapItems = [
  { questionId: "q1", label: "Tu edad" },
  { questionId: "q2", label: "Cuándo te hinchás más" },
  { questionId: "q4", label: "Tu cena habitual" },
  { questionId: "q10", label: "Cómo llegás a la cena" },
  { questionId: "q15", label: "Tiempo para cocinar" },
  { questionId: "q18", label: "Lo que querés resolver" },
];
